import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, to, href, variant = 'primary', className = '', ...props }) => {
  const baseStyles = "inline-flex items-center justify-center px-10 py-4 text-[10px] font-bold tracking-[0.2em] uppercase transition-all duration-500 rounded-full border-2";
  
  const variants = {
    primary: "bg-brand-charcoal border-brand-charcoal text-white hover:bg-brand-orange hover:border-brand-orange",
    outline: "bg-transparent border-brand-charcoal text-brand-charcoal hover:bg-brand-charcoal hover:text-white",
    ghost: "bg-transparent border-transparent text-brand-charcoal hover:text-brand-orange px-0",
    accent: "bg-brand-orange border-brand-orange text-white hover:bg-brand-teal hover:border-brand-teal"
  };

  const classes = `${baseStyles} ${variants[variant]} ${className}`;

  if (to) return <Link to={to} className={classes} {...props}>{children}</Link>;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} {...props}>{children}</a>;
  return <button className={classes} {...props}>{children}</button>;
};

export default Button;